import QMessageBox from './src/QMessageBox.js';

export default QMessageBox;
